/* useworkle.com — açılış animasyonu (vanilla karşılık)
   Kaynakta bu iş Next.js paketindeki JS'te yapılıyordu; paket taşınmadığı
   için IntersectionObserver ile yeniden yazıldı.

   Önemli fark: opacity:0 kuralı .is-anim sınıfına bağlı ve o sınıfı bu
   betik koyuyor. Betik yüklenmezse içerik normal görünür — kaynakta öyle
   değildi, orada JS düşerse 52 öğe görünmez kalıyordu. */
(function () {
  function kur() {
    var kokler = document.querySelectorAll('.wk');
    for (var i = 0; i < kokler.length; i++) {
      var kok = kokler[i];
      if (kok.dataset.wkHazir) continue;
      kok.dataset.wkHazir = '1';

      var ogeler = kok.querySelectorAll('[data-ns-animate]');
      if (!ogeler.length) continue;

      /* IntersectionObserver yoksa hiç gizleme: içerik olduğu gibi kalsın. */
      if (!('IntersectionObserver' in window)) continue;
      kok.classList.add('is-anim');

      var gozlemci = new IntersectionObserver(function (girdiler, g) {
        for (var j = 0; j < girdiler.length; j++) {
          if (!girdiler[j].isIntersecting) continue;
          girdiler[j].target.classList.add('is-in');
          g.unobserve(girdiler[j].target);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      for (var k = 0; k < ogeler.length; k++) gozlemci.observe(ogeler[k]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
  /* Tema editörü bölümü yeniden basabilir. */
  document.addEventListener('shopify:section:load', kur);
})();
